module.exports = __webpack_public_path__ + "img/camera_icon.b28006ff.svg";